import { render, staticRenderFns } from "./ErpCostUpload.vue?vue&type=template&id=3956bf50&"
import script from "./ErpCostUpload.vue?vue&type=script&lang=js&"
export * from "./ErpCostUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports